import { render } from "./EditDokumentDialog.vue?vue&type=template&id=a2c5541a&ts=true"
import script from "./EditDokumentDialog.vue?vue&type=script&lang=ts"
export * from "./EditDokumentDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__